document.querySelectorAll('.collection-hero__description-wrapper[data-clamped]').forEach((wrapper) => {
  const description = wrapper.querySelector('.collection-hero__description');
  const toggle = wrapper.querySelector('.collection-hero__description-toggle');
  if (!description || !toggle) return;

  requestAnimationFrame(() => {
    if (description.scrollHeight > description.clientHeight + 2) {
      toggle.hidden = false;
    }
  });

  toggle.addEventListener('click', () => {
    const expanded = wrapper.hasAttribute('data-expanded');
    if (expanded) {
      wrapper.removeAttribute('data-expanded');
      toggle.textContent = 'Ver más';
    } else {
      wrapper.setAttribute('data-expanded', '');
      toggle.textContent = 'Ver menos';
    }
  });
});
